var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "500px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.datiGeneraliLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.riferimentoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.riferimentoValue),
      expression: "riferimentoValue"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "riferimentoId"
    },
    domProps: {
      "value": (_vm.riferimentoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.riferimentoValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!this.$root.ecIntegrationActive) ? _c('cfg', {
    staticClass: "form-group",
    attrs: {
      "cid": "shopCart.tipoOrdine",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.tipoOrdineLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": 'type',
      "id": "tipoOrdineId",
      "disabled": _vm.tipoOrdineDisabled,
      "options": _vm.tipoOrdineOptionsValue,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.firstUpperTranslate('order type')
    },
    on: {
      "input": function($event) {
        _vm.onOrderTypeChange(_vm.tipoOrdineValue)
      }
    },
    model: {
      value: (_vm.tipoOrdineValue),
      callback: function($$v) {
        _vm.tipoOrdineValue = $$v
      },
      expression: "tipoOrdineValue"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(!this.$root.ecIntegrationActive) ? _c('cfg', {
    staticClass: "form-group",
    attrs: {
      "cid": "shopCart.vsRif",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.vsRiferimentoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vsRiferimentoValue),
      expression: "vsRiferimentoValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "vsRiferimentoId"
    },
    domProps: {
      "value": (_vm.vsRiferimentoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vsRiferimentoValue = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$root.token.hidePrices && _vm.showScontoBase) ? _c('cfg', {
    staticClass: "form-group",
    attrs: {
      "cid": "shopCart.scontoBase",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v(_vm._s(_vm.scontoBaseLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.scontoBaseValue),
      expression: "scontoBaseValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "number",
      "id": "scontoBaseId"
    },
    domProps: {
      "value": (_vm.scontoBaseValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scontoBaseValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e()], 1)]), _vm._v(" "), (!this.$root.ecIntegrationActive) ? _c('div', {
    staticClass: "row"
  }, [_c('cfg', {
    staticClass: "col-sm-12 form-group",
    attrs: {
      "cid": "shopCart.note",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "controls col-sm-2"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.noteLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteValue),
      expression: "noteValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "100%",
      "max-height": "138px"
    },
    attrs: {
      "id": "noteId",
      "rows": "2",
      "data-role": "textarea"
    },
    domProps: {
      "value": (_vm.noteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteValue = $event.target.value
      }
    }
  })])])], 1) : _vm._e()]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.importoLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importoValue),
      expression: "importoValue"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "",
      "id": "importoId",
      "type": "text"
    },
    domProps: {
      "value": (_vm.importoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importoValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(" ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "columns": _vm.gridProdAttributesCfg.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "others": _vm.others,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.gridProdAttributesCfg.title
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [(!this.$root.ecIntegrationActive) ? _c('div', [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forwardClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('continue')))])]), _vm._v(" "), (_vm.$Behaviors.addProductFromCart) ? _c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "140px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addProductClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('add') + ' ' + _vm.$Jed.translate('product')))])]) : _vm._e(), _vm._v(" "), (_vm.$Behaviors.loadOrderItemsFromExcel) ? _c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "140px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadFromExcelClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('load') + ' ' + _vm.$Jed.translate('excel')))])]) : _vm._e(), _vm._v(" "), (_vm.$Behaviors.availabilityStatus.updateButton) ? _c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "160px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$root.updateAvailability()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('update availability')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.nuovoOrdineBtn",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "disabled": _vm.arrayToTable.length == 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cleanShopCartClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('new order')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(this.$root.ecIntegrationActive) ? _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.isSyncing
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cartSend($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('send')))])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('purchasePopup', {
    attrs: {
      "id": "purchasePopup",
      "chooseQty": _vm.chooseQty,
      "purchaseSid": _vm.purchaseSid,
      "purchaseDes": _vm.purchaseDes,
      "purchasePrice": _vm.purchasePrice,
      "popupHeight": _vm.popupHeight,
      "product": _vm.product,
      "arrayToTable": _vm.arrayToTable,
      "tableConfigs": _vm.gridProdAttributesCfg
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" \n            ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ac68f4f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/ShopCart.vue
// module id = 1666
// module chunks = 1